type OrderRiddleTextProps = {
  /** Загадка заказа (GDD «Загадка доставки»). */
  text: string;
};

/** Текст загадки под подписью «Описание». */
export function OrderRiddleText({ text }: OrderRiddleTextProps) {
  return <p className="new-delivery-texts__riddle">{text}</p>;
}
